import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaRegUserCircle } from "react-icons/fa";
import { BiKey, BiUser } from "react-icons/bi";
import { signIn } from "../actions/adminActions";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.css";
import { getCartCountAndBag, getCartItem } from "../actions/storeActions";
import { io } from "socket.io-client";
import { useRef } from "react";
import { SocketData } from "../context/SocketContext";
const Login = () => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { socket } = SocketData();
  const [logging, setLogging] = useState(false);
  const [formData, setFormData] = useState({
    user: "",
    password: "",
  });

  const handleNotification = () => {
    socket.current.emit("accountCreation");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLogging(true);
    const dataCredential = {
      user: formData.user,
      password: formData.password,
    };
    const {
      param,
      msg,
      id,
      admin: isAdmin,
    } = await dispatch(signIn(dataCredential, navigate));
    if (param === "invalid") {
      alertify.error(`${msg}`);
    } else if (isAdmin) {
      dispatch({ type: "USER_LOGGED_IN", payload: id });
      navigate("/admin", {
        state: {
          message: `Welcome back ${formData.user} `,
        },
      });
    } else if (!isAdmin) {
      const { cartCount, checkoutCount } = await getCartCountAndBag();
      dispatch({ type: "USER_LOGGED_IN", payload: id });
      dispatch({ type: "CART_ITEMS", payload: { cartCount, checkoutCount } });
      if (state?.prevState) {
        navigate(`${state.prevState}`, {
          state: {
            message: `Welcome back ${formData.user} `,
          },
        });
      } else {
        navigate(`/user/account`, {
          state: {
            message: `Welcome back ${formData.user} `,
          },
        });
      }
    }
    setLogging(false);
  };

  useEffect(() => {
    return () => setFormData({ user: "", password: "" });
  }, []);

  useEffect(() => {
    if (state?.message) {
      alertify.set("notifier", "position", "top-right");
      alertify.error(state?.message);
    }
  }, [state]);
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  return (
    <div className="login-container">
      <form className="signin-container" onSubmit={handleSubmit}>
        <FaRegUserCircle className="logo" />
        <h3>Welcome to Amy Store!</h3>
        <div className="custom-style-input">
          <BiUser />
          <input
            type="text"
            autoComplete="off"
            id="text"
            name="user"
            onChange={handleChange}
          />
        </div>
        <div className="custom-style-input">
          <BiKey />
          <input
            type="password"
            id="password"
            name="password"
            onChange={handleChange}
          />
        </div>
        <button disabled={logging} type="submit" className="authBtn">
          {logging ? (
            <div>
              <FontAwesomeIcon icon={faCog} className="fa-spin" />
              {" Please wait "}
            </div>
          ) : (
            "Login"
          )}
        </button>
        <p>
          No account?{" "}
          <span className="text-link" onClick={() => handleNotification()}>
            Ask admin
          </span>{" "}
        </p>
      </form>
    </div>
  );
};

export default Login;
